import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { debounce } from 'lodash';
import { getFileList, deleteFile, createFile, validFileExists, deleteFiles, getNewSignedS3Url } from "@/api/file_service";
import { createFolder, getS3BucketList, createLocalFolder } from "@/api/folder_service";
import infoList from "@/components/mixins/infoList";
import ProgressBar from "./components/processBar.vue";
import { mapGetters } from 'vuex';
import { getCookie } from "@/utils/cookie";
var inbound = "xdata-files";
var outbound = "xdata-files";
export default {
  name: "fileservice",
  mixins: [infoList],
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  components: {
    ProgressBar: ProgressBar
  },
  data: function data() {
    return {
      progress: false,
      progressPercent: 0,
      importStatus: "",
      selectedFiles: [],
      listApi: getFileList,
      pid: 0,
      path: '',
      selectedFile: {},
      fileId: 0,
      level: 1,
      permission: 0,
      loading: false,
      isInbound: false,
      dialogFormVisible: false,
      uploadFileName: "",
      saveRecord: true,
      uploadFlag: true,
      breadBackupList: [],
      breadList: [],
      formData: {},
      formDataUpload: {},
      searchInfo: {
        userId: ""
      },
      tableData: [],
      batchFileCount: 0,
      processBatchFileCount: 0
    };
  },
  watch: {},
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            this.searchInfo.userId = this.userInfo.ID;
            _context.next = 1;
            return this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    /**
     * 下载 download 	1
     上传 upload		2
     删除 delete		4
     */
    hasUploadPermissionFunc: function hasUploadPermissionFunc() {
      var a = this.permission;
      return a == 2 || a == 3 || a == 6 || a == 7;
    },
    hasDownloadPermissionFunc: function hasDownloadPermissionFunc() {
      // const permission = 0;
      var a = this.permission;
      return a == 1 || a == 3 || a == 5 || a == 7;
    },
    hasDeletePermissionFunc: function hasDeletePermissionFunc() {
      var a = this.permission;
      return a == 4 || a == 6 || a == 7 || a == 5;
    },
    deleteFileButtonFunc: function deleteFileButtonFunc() {
      if (this.selectedFile.length > 1) {
        this.deleteAll(this.selectedFile);
      } else {
        this.deleteFileRowFunc(this.selectedFile);
      }
    },
    customColorMethod: function customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    selectFunc: function selectFunc(selection) {
      // if(selection){
      this.selectedFile = selection;
      // }
    },
    getS3File: function () {
      var _getS3File = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(prefix) {
        var res, lists, _t;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loading = true;
              _context2.next = 1;
              return getS3BucketList({
                Prefix: prefix,
                page: this.page,
                pageSize: this.pageSize
              });
            case 1:
              res = _context2.sent;
              if (res.code == 0) {
                lists = res.data.list || [];
                this.tableData = lists;
                this.page = res.data.page;
                this.pageSize = res.data.pageSize;
                this.total = res.data.total;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t = _context2["catch"](0);
            case 3:
              _context2.prev = 3;
              this.loading = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2, 3, 4]]);
      }));
      function getS3File(_x) {
        return _getS3File.apply(this, arguments);
      }
      return getS3File;
    }(),
    refresh: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 1;
              return this.getTableData();
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }(),
    refreshs3: function () {
      var _refreshs = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 1;
              return this.getS3File(inbound + this.path + "/");
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function refreshs3() {
        return _refreshs.apply(this, arguments);
      }
      return refreshs3;
    }(),
    levelgt3: function levelgt3() {
      return this.level >= 3;
    },
    isInboundFunc: function isInboundFunc() {
      return this.isInbound;
    },
    changeType: function changeType(row, column, cellValue) {
      if (cellValue) {
        if (row.isFolder) {
          return cellValue == 1 ? 'inbound' : 'outbound';
        } else {
          return "file";
        }
      }
    },
    showType: function showType(row) {
      if (cellValue) {
        if (row.isFolder) {
          return false;
        } else {
          return true;
        }
      }
    },
    changeDate: function changeDate(row) {
      return this.$moment(row.CreatedAt).format("YYYY-MM-DD HH:mm:ss");
    },
    donotshowfolder: function donotshowfolder(row, column, cellValue) {
      if (cellValue) {
        if (!row.isFolder) {
          if (cellValue / 1000 < 1) {
            return cellValue + "B";
          } else if (cellValue / 1000 < 1000) {
            return (cellValue / 1000).toFixed(2) + "KB";
          } else {
            return (cellValue / 1000 / 1000).toFixed(2) + "MB";
          }
        }
      } else {
        return "-";
      }
    },
    isIE: function isIE() {
      var b = window.navigator.userAgent.indexOf("MSIE") > 0;
      return b;
    },
    getBreadTableData: function getBreadTableData(id) {
      if (id instanceof Object) {
        var name = id.name;
        this.path = "/" + name;
        this.pid = id.ID;
        id = id.ID;
        if (name != this.breadList.at(-1).name) {
          this.breadList.pop();
          this.level = "2";
        }
      } else {
        this.pid = 0;
        this.level = 1;
        this.path = "";
        this.breadList = [];
      }
      this.searchInfo.userId = this.userInfo.ID;
      this.searchInfo.pid = id;
      this.getTableData();
    },
    getDataCustom: function () {
      var _getDataCustom = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var level,
          _args5 = arguments;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              level = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : undefined;
              if (!(level >= 2 || this.level >= 2)) {
                _context5.next = 2;
                break;
              }
              _context5.next = 1;
              return this.getS3File(inbound + this.path + "/");
            case 1:
              _context5.next = 3;
              break;
            case 2:
              _context5.next = 3;
              return this.getTableData();
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getDataCustom() {
        return _getDataCustom.apply(this, arguments);
      }
      return getDataCustom;
    }(),
    handleFileCurrentChange: function handleFileCurrentChange(val) {
      this.page = val;
      this.getDataCustom();
    },
    handleFileSizeChange: function handleFileSizeChange(val) {
      this.pageSize = val;
      this.getDataCustom();
    },
    clickFolder: function () {
      var _clickFolder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(row) {
        var _this = this;
        var findKey, permissionList, newPermission, val, a;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              findKey = function _findKey(obj, value) {
                var compare = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
                  return a == b;
                };
                return Object.keys(obj).find(function (k) {
                  return compare(obj[k], value);
                });
              };
              if (!this.isOperating) {
                _context6.next = 1;
                break;
              }
              return _context6.abrupt("return");
            case 1:
              this.isOperating = true;
              this.pid = row.ID;
              // this.permission = row.permission;
              permissionList = [];
              row.permission.split(',').forEach(function (p) {
                permissionList = permissionList.concat(_this.global.filePermission[p]);
              });
              newPermission = _toConsumableArray(new Set(permissionList)); // console.log('this.permission ',this.permission, newPermission);
              val = Object.values(this.global.filePermission).find(function (val) {
                return val.length === newPermission.length && val.sort().toString() === newPermission.sort().toString();
              });
              this.permission = findKey(this.global.filePermission, val);
              // console.log('this.level ',this.level);
              a = this.breadList;
              if (row.level == '1' && a.length == 0) {
                a.push(row);
                this.path += "/" + row.name;
              } else if (row.level == '2') {
                a.push(row);
                this.path += "/" + row.name;
              }
              this.breadList = a;
              this.isInbound = row.folderType == '1';
              this.searchInfo.pid = row.ID;
              this.searchInfo.userId = this.userInfo.ID;
              this.getDataCustom(row.level).then(function () {
                _this.level = "" + (parseInt(row.level) + 1);
                _this.isOperating = false;
              }).catch(function () {
                _this.level = "" + (parseInt(row.level) + 1);
                _this.isOperating = false;
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function clickFolder(_x2) {
        return _clickFolder.apply(this, arguments);
      }
      return clickFolder;
    }(),
    rowIsFolder: function rowIsFolder(row) {
      return row.isFolder === true;
    },
    downloadAllFunc: function downloadAllFunc() {
      var a = this.selectedFile;
      if (a.length > 0) {
        this.downloadAll(a);
      }
    },
    downloadAll: function () {
      var _downloadAll = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(a) {
        var that, elink, i, interval;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              that = this;
              elink = document.createElement("a");
              i = 0; // const size = a.length;
              interval = setInterval(function () {
                var abool = that.downloadByRow(a.pop(), elink);
                if (abool) {
                  i += 1;
                }
                if (a.length == 0) {
                  document.body.removeChild(elink);
                  clearInterval(interval);
                }
              }, 500);
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function downloadAll(_x3) {
        return _downloadAll.apply(this, arguments);
      }
      return downloadAll;
    }(),
    downloadByRow: function () {
      var _downloadByRow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(row, elink) {
        var bool, aObj, t, res;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              bool = false;
              if (elink == null) {
                bool = true;
                elink = document.createElement("a");
              }
              aObj = {};
              t = "/xdata-files"; //this.isInbound ? "/inbound": "/outbound";
              aObj.bucket = t + "" + this.getPath(row);
              aObj.type = row.folderType;
              aObj.name = row.name;
              _context8.next = 1;
              return getNewSignedS3Url(aObj);
            case 1:
              res = _context8.sent;
              if (!(res.code == 0)) {
                _context8.next = 2;
                break;
              }
              elink.href = res.data.url;
              document.body.appendChild(elink);
              elink.click();
              return _context8.abrupt("return", true);
            case 2:
              if (bool) {
                document.body.removeChild(elink);
              }
              return _context8.abrupt("return", bool);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function downloadByRow(_x4, _x5) {
        return _downloadByRow.apply(this, arguments);
      }
      return downloadByRow;
    }(),
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
    },
    getPath: function getPath() {
      var str1 = this.path;
      return str1;
    },
    deleteAll: function () {
      var _deleteAll = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var _this2 = this;
        var a;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              a = this.selectedFile;
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var res;
                return regeneratorRuntime.wrap(function (_context9) {
                  while (1) switch (_context9.prev = _context9.next) {
                    case 0:
                      _context9.next = 1;
                      return deleteFiles({
                        files: a,
                        extra: _this2.getPath()
                      });
                    case 1:
                      res = _context9.sent;
                      if (res.code === 0) {
                        _this2.$message.success("删除成功");
                      }
                      _this2.getDataCustom();
                      return _context9.abrupt("return", true);
                    case 2:
                    case "end":
                      return _context9.stop();
                  }
                }, _callee9);
              }))).catch(function () {
                return false;
              });
            case 1:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this);
      }));
      function deleteAll() {
        return _deleteAll.apply(this, arguments);
      }
      return deleteAll;
    }(),
    deleteFileRowFunc: function () {
      var _deleteFileRowFunc = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(row) {
        var _this3 = this;
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.$confirm(this.$t('common.delete_warning'), "", {
                confirmButtonText: this.$t('common.confirm'),
                cancelButtonText: this.$t('common.cancel'),
                type: "warning"
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
                var res;
                return regeneratorRuntime.wrap(function (_context1) {
                  while (1) switch (_context1.prev = _context1.next) {
                    case 0:
                      _this3.formData.deletedby = _this3.userInfo.nickName;
                      _this3.formData.extra = _this3.getPath(row);
                      _this3.formData.name = row.name;
                      if (row.ID) {
                        _this3.formData.ID = row.ID;
                      }
                      _context1.next = 1;
                      return deleteFile(_this3.formData);
                    case 1:
                      res = _context1.sent;
                      if (res.code === 0) {
                        _this3.$message.success("删除成功");
                      } else {
                        _this3.$message.error(res.msg);
                      }
                      _this3.getDataCustom();
                    case 2:
                    case "end":
                      return _context1.stop();
                  }
                }, _callee1);
              }))).catch(function () {
                _this3.$message({
                  type: "info",
                  message: _this3.$t('common.cancel')
                });
              });
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function deleteFileRowFunc(_x6) {
        return _deleteFileRowFunc.apply(this, arguments);
      }
      return deleteFileRowFunc;
    }(),
    handleClose: function handleClose() {
      this.formData.name = "";
      this.formData.folderType = null;
      this.dialogFormVisible = false;
    },
    createFolderByRow: function createFolderByRow(row) {
      // this.selectItemFlag = false;
      this.formData = {};
      this.formData.ID = null;
      this.formData.pid = row.ID;
      this.formData.folderType = '1';
      this.formData.createdAt = this.$moment().format('YYYY-MM-DD HH:mm:ss');
      this.formData.level = "" + (parseInt(row.level) + 1);
      this.formData.isFolder = true;
      this.formData.createdBy = this.userInfo.nickName;
      this.dialogFormVisible = true;
    },
    createFolderFunc: function createFolderFunc() {
      // this.selectItemFlag = false;
      this.formData = {};
      this.formData.ID = null;
      this.formData.pid = this.pid;
      this.formData.folderType = '1';
      this.formData.level = this.level;
      this.formData.createdAt = this.$moment().format('YYYY-MM-DD HH:mm:ss');
      this.formData.isFolder = true;
      this.formData.createdBy = this.userInfo.nickName;
      this.dialogFormVisible = true;
    },
    closeDialog: function closeDialog() {
      this.formData.ID = null;
      this.formData.name = "";
      this.formData.folderType = null;
      this.dialogFormVisible = false;
    },
    enterDialog: function () {
      var _enterDialog = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 1;
              return createFolder(this.formData);
            case 1:
              res = _context11.sent;
              if (res.code === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('common.success')
                });
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                });
              }
              this.dialogFormVisible = false;
              _context11.next = 2;
              return this.getTableData();
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function enterDialog() {
        return _enterDialog.apply(this, arguments);
      }
      return enterDialog;
    }(),
    strSlice: function strSlice(a) {
      return a.slice(a.indexOf('/') + 1);
    },
    downloadFileFunc: function downloadFileFunc() {},
    uploadValid: function uploadValid(file) {
      //beforeUpload
      var str = file.type;
      var name = file.name;
      this.formDataUpload.filename = name;
      var isAllow = name.indexOf('.docx') > 0 || name.indexOf('.doc') > 0 || name.indexOf('.xls') > 0 || name.indexOf('.xlsx') > 0 || name.indexOf('.csv') > 0 || str.indexOf('vnd.openxmlformats') > 0 || str.indexOf('vnd.ms-excel') > 0 || str.indexOf('csv') > 0;
      var isLt500M = file.size / 1024 / 1024 < 500;
      if (!isLt500M) {
        this.$message.error({
          message: this.$t('fileManage.image_size'),
          color: 'negative'
        });
      }
      if (!isAllow) {
        this.$message.error({
          message: this.$t('fileManage.image_format'),
          color: 'negative'
        });
      }
      this.formDataUpload.fileSize = "" + file.size;
      return isLt500M;
    },
    fileChanged: function fileChanged(file, fileList) {
      // console.log(file, fileList)
      // this.selectedFiles = fileList;
      this.batchFileCount = fileList.length;
      console.log('this.batchFileCount', this.batchFileCount);
    },
    onExceed: function onExceed(file, fileList) {
      this.$message.error("最多选取5个文件");
    },
    handleSuccess: function handleSuccess(res, file) {
      console.log('----success');
    },
    beforeUploadFunc: function beforeUploadFunc(file) {
      var that = this;
      return new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(resolve, reject) {
          var name, validFilenameRegex, res;
          return regeneratorRuntime.wrap(function (_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                name = file.name;
                that.formDataUpload.fileSize = "" + file.size;
                that.uploadFileName = name;

                //验证文件名是否合法
                validFilenameRegex = /^(?:[!'-\*\x2D\.0-9A-Z_a-z\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFA6D\uFA70-\uFAD9]|\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+( (?:[!'-\*\x2D\.0-9A-Z_a-z\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFA6D\uFA70-\uFAD9]|\uD81B[\uDFE2\uDFE3\uDFF0\uDFF1]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])+)*$/;
                if (validFilenameRegex.test(file.name)) {
                  _context12.next = 1;
                  break;
                }
                that.$message.error("file name is invalid, please use the following characters: 0-9 a-z A-Z! - _ . * ' ( )");
                return _context12.abrupt("return", reject(false));
              case 1:
                _context12.next = 2;
                return validFileExists({
                  Bucket: "/xdata-files" + that.path + "/",
                  FileName: name
                });
              case 2:
                res = _context12.sent;
                if (!(res && res.code == 0 && res.data.hasFile == "1")) {
                  _context12.next = 3;
                  break;
                }
                that.$confirm("文件列表中已有 " + name + "，是否覆盖？", {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  cancelButtonClass: "btn-custom-cancel",
                  type: 'warning'
                }).then(function () {
                  that.uploadFlag = true;
                  that.saveRecord = true;
                  return resolve(true);
                }).catch(function () {
                  that.uploadFlag = false;
                  that.saveRecord = false;
                  return reject(false);
                });
                _context12.next = 4;
                break;
              case 3:
                return _context12.abrupt("return", resolve(true));
              case 4:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function (_x7, _x8) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    // beforeUploadFunc:debounce(async function (file){
    //   const name = file.name;
    //   this.formDataUpload.fileSize = "" + file.size;
    //   this.uploadFileName = name;
    //   // await console.log('name',name);
    //   const res = await validFileExists({Bucket: "/xdata-files" + this.path + "/",FileName: name});
    //   if(res && res.code == 0 && res.data.hasFile == "1"){
    //     this.$confirm("文件列表中已有 "+ name +"，是否覆盖？",{
    //       confirmButtonText: '确定',
    //       cancelButtonText:  '取消',
    //       cancelButtonClass: "btn-custom-cancel",
    //       type: 'warning',
    //     }).then(() => {
    //         this.uploadFlag = true;
    //         this.saveRecord = true;
    //         return true;
    //       })
    //       .catch(() => {
    //         this.uploadFlag = false;
    //         this.saveRecord = false;
    //         return false;
    //       });
    //   }
    // },200,{
    //   leading: true, // 在延迟开始前立即调用事件
    //   trailing: false, // 在延时结束后不调用,保证事件只被触发一次
    // },),
    createRecord: function () {
      var _createRecord = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(name) {
        var formData;
        return regeneratorRuntime.wrap(function (_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!(name == "")) {
                _context13.next = 1;
                break;
              }
              return _context13.abrupt("return");
            case 1:
              formData = {};
              formData.ID = null;
              formData.pid = this.pid;
              formData.isFolder = false;
              formData.folderType = '1';
              formData.level = this.level;
              formData.name = name;
              formData.createdBy = this.userInfo.nickName;
              formData.fileSize = this.formDataUpload.fileSize;
              createFile(formData);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function createRecord(_x9) {
        return _createRecord.apply(this, arguments);
      }
      return createRecord;
    }(),
    upload: function () {
      var _upload = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(file) {
        var _this4 = this;
        var that, formData1, notify, url, res1, _t2;
        return regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              that = this; //上传时判断是否有重复名字的文件,如果有，增加后缀_1
              if (this.uploadFlag) {
                _context14.next = 1;
                break;
              }
              this.$message.info("Cancel Upload");
              return _context14.abrupt("return");
            case 1:
              this.progress = true;
              formData1 = new FormData(); // console.log('name ,' + file.filename)
              formData1.append('path', this.path);
              formData1.append('file', file.file); //process.env.VUE_APP_BASE_API +
              formData1.append('key', getCookie("userId") + file.file.uid); //process.env.VUE_APP_BASE_API +
              _context14.prev = 2;
              setTimeout(function () {
                var h = _this4.$createElement;
                notify = _this4.$notify({
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  message: h('ProgressBar', {
                    // 使用自定义组件
                    ref: "progressBar".concat(getCookie("userId") + file.file.uid),
                    props: {
                      progress: that.progressPercent,
                      fileName: file.file.name
                    }
                  })
                });
              }, file.file.size / 1024 / 1024 > 5 ? 60 : 0);
              // let url = "/api/file/uploadFiles"
              // if ( file.file.size/1024/1024 > 5) {
              //   url = "/api/file/uploadFilesSync"
              // }
              url = "/api/file/uploadFilesTest";
              _context14.next = 3;
              return this.$axios.post(url, formData1, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                  var percent = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
                  // const false_percent = Math.trunc(percent*0.8);
                  this.$refs["progressBar".concat(getCookie("userId") + file.file.uid)] && this.$refs["progressBar".concat(getCookie("userId") + file.file.uid)].setProgress(percent - 1);
                  if (percent == 99) {
                    // if (file.file.size/1024/1024 > 5) {
                    //   const e = new EventSource(`sse/ssmService/socketConnection?UserId=${getCookie("userId")}&TraceId=${file.file.uid}`, { withCredentials: true })
                    //   e.onmessage = function(event) {
                    //     console.log(event)
                    //     const realypercent = parseInt(event.data, 10);
                    //     if (realypercent >= false_percent) {
                    //       that.$refs[`progressBar${getCookie("userId")+file.file.uid}`] &&
                    //       that.$refs[`progressBar${getCookie("userId")+file.file.uid}`].setProgress(realypercent)
                    //       if (realypercent === 100) {
                    //         notify.close()
                    //         that.processBatchFileCount +=1
                    //         if (that.batchFileCount === that.processBatchFileCount) {
                    //           // 全部上传完成
                    //           console.log('---完成')
                    //           that.$refs.upload.clearFiles()
                    //           e.close()
                    //         }
                    //         setTimeout(() => {
                    //           that.getDataCustom()
                    //         }, 300);
                    //       }
                    //     }
                    //   }
                    // } else {
                    that.processBatchFileCount += 1;
                    if (that.batchFileCount === that.processBatchFileCount) {
                      // 全部上传完成
                      console.log('---完成');
                      that.$refs.upload.clearFiles();
                    }
                  }
                  // }
                }.bind(this)
              });
            case 3:
              res1 = _context14.sent;
              this.$refs.upload.clearFiles();
              if (res1 != null) {
                if (res1.data.code !== 0) {
                  this.$message.error(res1.data.msg);
                  notify.close();
                } else {
                  setTimeout(function () {
                    _this4.$refs["progressBar".concat(getCookie("userId") + file.file.uid)].setProgress(100);
                    notify.close();
                    that.getDataCustom();
                  }, 300);
                }
              }
              // this.$message.success("Upload Success!");
              _context14.next = 5;
              break;
            case 4:
              _context14.prev = 4;
              _t2 = _context14["catch"](2);
              console.log(_t2);
              this.progress = false;
              this.importStatus = "exception";
              // console.log("upload error ",error);
            case 5:
              _context14.prev = 5;
              this.saveRecord = true;
              this.progress = false;
              // this.getDataCustom();
              return _context14.finish(5);
            case 6:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this, [[2, 4, 5, 6]]);
      }));
      function upload(_x0) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }
};